import { Alert, AppBar, Box, IconButton, Snackbar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import WindowIcon from "@mui/icons-material/Window";
import { useState } from "react";
import { motion } from "framer-motion";
import MobileSearchModal from "./mobileSearchModal";
import AppDrawer from "../appDrawer";
import LoginRegisterDialog from "../appDialog/login";
import FavorDialog from "../appDialog/favor";
import SearchDialog from "../appDialog";
import GameCategoryDialog from "../appDialog/type";
import TutorialVideoDialog from "../appDialog/TutorialVideoDialog";
import FilterMenuButton from "../common/FilterMenuButton"; // ✅ 新增导入
import { R2DOMAIN } from "../../config";
import LuckyWheelDialog from "../appDialog/LuckyWheelDialog";
import CameraIcon from '@mui/icons-material/Camera';
import { useUser } from "../../contexts/userContext";
import FollowDialog from "../appDialog/followDialog";
import MsgSnackBar from '../common/msgSnack';




export default function NavBarMobile({ setRealoding,handleFilterChange, matches }) {
  const [openSearch, setOpenSearch] = useState(false);
  const [openFire, setOpenFire] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const [open, setOpen] = useState(false);
  const [openFavor, setOpenFavor] = useState(false);
  const [chipTitle, setChipTitle] = useState(null);
  const [openType, setOpenType] = useState(false);
  const [openTutorial, setOpenTutorial] = useState(false);
  const [openLucky, setOpenLucky] = useState(false);
  const { userData } = useUser();
  const [openFollow, setOpenFollow] = useState(false);
  const [msgSnackOpen, setMsgSnackOpen] = useState(false);

  // 登录提示 Snackbar
    const [loginSnackOpen, setLoginSnackOpen] = useState(false);
    const handleLoginSnackClose = (event, reason) => {
      if (reason === 'clickaway') return;
      setLoginSnackOpen(false);
    };
  

  const handleOpenSearch = (text) => {
    setChipTitle(text);
    setOpenFire(true);
  };

  

  // 右侧按钮滑入动画
  const iconVariants = {
    hidden: { x: 40, opacity: 0 },
    visible: (i) => ({
      x: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 400, damping: 20, delay: i * 0.1 },
    }),
  };

  // ✅ 现在第一个是 FilterMenuButton
  const icons = [
  
  { custom: 4, icon: <CameraIcon sx={{ fontSize: 20 }} />, onClick: () => {
        if (!userData) {
          setLoginSnackOpen(true); // 👈 提示用户登录
          return;
        }
        setChipTitle('我关注的');
        setOpenFollow(true);
      }, },
  { custom: 2, icon: <WindowIcon sx={{ fontSize: 20 }} />, onClick: () => setOpenType(true) },   
  { custom: 3, icon: <LocalFireDepartmentIcon sx={{ fontSize: 20 }} />, onClick: () => handleOpenSearch("夜未央") },
  // 其余图标保持不变 ↓
  {
    custom: 0,
    component: (
      <FilterMenuButton
        onChange={handleFilterChange}
        showGroups={["sort", "platform", "people", "finish", "type", "category"]}
      />
    )
  },
  { custom: 1, icon: <SearchIcon sx={{ fontSize: 20 }} />, onClick: () => setOpenSearch(true) },
];


  return (
    <>
    <MsgSnackBar vertical="bottom" msg="已经为您滚动到最新发布了" msgSnackOpen={msgSnackOpen} setMsgSnackOpen={setMsgSnackOpen} />
    <LoginRegisterDialog open={openLogin} onClose={() => setOpenLogin(false)} />
          {/* 登录提示 Snackbar */}
          <Snackbar
            open={loginSnackOpen}
            autoHideDuration={3000}
            onClose={handleLoginSnackClose}
            anchorOrigin={{ vertical: 'center', horizontal: 'center' }} // 居中
            sx={{
              '& .MuiPaper-root': {
                backgroundColor: 'rgba(0,0,0,0.6)', // 半透明黑色
                color: '#fff',                     // 白色文字
                borderRadius: 2,                   // 圆角
                padding: '12px 24px',              // 内边距
                minWidth: '200px',
                textAlign: 'center',
              },
            }}
          >
            <Alert onClose={handleLoginSnackClose} severity="warning" sx={{ width: '100%' }}>
              请先登录才能使用此功能
            </Alert>
          </Snackbar>
      {/* 各类弹窗 */}
      <SearchDialog openSearch={openFire} setOpenSearch={setOpenFire} matches={matches} chipTitle={chipTitle} />
      <FavorDialog openSearch={openFavor} setOpenSearch={setOpenFavor} matches={matches} chipTitle={chipTitle} />
      <FollowDialog openSeries={openFollow} setOpenSeries={setOpenFollow} matches={matches} chipTitle={chipTitle} />
      <GameCategoryDialog matches={matches} open={openType} setOpenType={setOpenType} />
      <TutorialVideoDialog
        open={openTutorial}
        onClose={() => setOpenTutorial(false)}
        videoUrl={`${R2DOMAIN}/24e9f8e76eab46b9a8c8cecafb3caded.m3u8`}
      />

      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          zIndex: 10,
          backdropFilter: "blur(12px)",
          backgroundColor: "rgba(255,255,255,0.7)",
          color: "#000",
          px: 1,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: 50 }}>
          {/* 左侧菜单 */}
          <IconButton onClick={() => setOpen(true)} sx={{ color: "inherit" }}>
            <MenuIcon />
          </IconButton>

          {/* 右侧功能按钮 */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {icons.map((item, index) => (
              <motion.div
                key={index}
                custom={item.custom || index}
                initial="hidden"
                animate="visible"
                variants={iconVariants}
              >
                {item.component ? (
                  item.component
                ) : (
                  <IconButton onClick={item.onClick} sx={{ color: "inherit" }}>
                    {item.icon}
                  </IconButton>
                )}
              </motion.div>
            ))}
          </Box>
        </Box>
      </AppBar>

      {/* 其他弹窗 */}
      <MobileSearchModal openSearch={openSearch} setOpenSearch={setOpenSearch} />
      <AppDrawer open={open} setOpen={setOpen} setRealoding={setRealoding} />
      <LoginRegisterDialog open={openLogin} onClose={() => setOpenLogin(false)} />
      <LuckyWheelDialog open={openLucky} onClose={()=>{setOpenLucky(false)}}></LuckyWheelDialog>
    </>
  );
}
